import { http } from 'public/utils/http.js'

let homeModulePromise = null

export function fetchModule (force = false) {
  if (homeModulePromise && !force) {
    return homeModulePromise
  }

  homeModulePromise = http('system.homeModuleGroup.show', { moduleType: '10', _key: Math.random() }, false)
  return homeModulePromise
}




// WEBPACK FOOTER //
// ./src/layout/components/common-module-list/fetch-module.js